import { Injectable} from '@angular/core';
import {TokenInterface} from '../../interfaces/token-interface';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  tokenName = 'authorization_token';
  private _tokenCache: TokenInterface | null = null;

  constructor() { }

  getToken(): TokenInterface | null {
    if (this._tokenCache) { return this._tokenCache; }
    const raw = localStorage.getItem(this.tokenName);
    if (!raw) { return null; }
    this._tokenCache = JSON.parse(raw);
    return this._tokenCache;
  }

  setToken(token: TokenInterface): void {
    const date = new Date();
    token.expires_in = (date.getTime() + (token.expires_in * 1000));
    localStorage.removeItem(this.tokenName);
    localStorage.setItem(this.tokenName, JSON.stringify(token));
    this._tokenCache = null;
  }


  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token) { return true; }

    const date = new Date (token.expires_in);
    if (!date) { return true; }
    return !(date.valueOf() > new Date().valueOf());
  }

  updateAccess(access: any, currentId: number): void {
    const user: any = this.getToken();

    if (currentId === user.permission.id) {
      user.permission.accesses = access;
    }
    this.setToken(user);
  }

  logout(): void {
    this._tokenCache = null;
    localStorage.removeItem(this.tokenName);
    localStorage.removeItem('user_table_setting');
    window.location.href = '/auth/login';
  }
}
